<template>
    <v-container fluid>
        <v-row>
            <v-col 
                style="display: flex; align-content: center; align-items: center;"
                cols="12"
                lg="12"
                md="12"
                sm="12">
                <h3>Tutorial</h3>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12"><br /></v-col>
        </v-row>
        <v-row>
            <v-col
                cols="12"
                lg="12"
                md="12"
                sm="12"
            >
                <v-expansion-panels
                    popout
                    multiple
                >
                        <v-expansion-panel
                            style="margin-bottom: 10px;"
                            v-for="(itemTutorial, index) in listTutorial" :key="index"
                        >
                            <v-expansion-panel-header
                                :key="index + 100"
                            >
                                <v-col
                                    cols="10"
                                    lg="10"
                                    md="10"
                                    sm="10"
                                >
                                    <label style="font-size: 20px !important; color: black;">{{ itemTutorial.topic }} </label>
                                </v-col>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>

                                <v-row style="height: 30px; margin-left: 0.0rem; border-bottom: solid 1px silver;">
                                    <v-col 
                                        cols="12"
                                        lg="5"
                                        md="5"
                                        sm="12"
                                    >
                                        <label>Description</label>
                                    </v-col>
                                    <v-col 
                                        cols="12"
                                        lg="3"
                                        md="3"
                                        sm="12"
                                    >
                                        <label>Link</label>
                                    </v-col>
                                    <v-col 
                                        cols="12"
                                        lg="3"
                                        md="3"
                                        sm="12"
                                    >
                                        <label>Materials</label>
                                    </v-col>
                                </v-row>

                                <v-row v-for="(itemTutorialItem, indexTutorialItem) in itemTutorial.listItem" :key="indexTutorialItem" style="height: 85px; margin-left: 0.0rem; margin-top: 20px;" >
                                    <v-col 
                                        cols="12"
                                        lg="5"
                                        md="5"
                                        sm="12"
                                    >
                                        <div style="font-size: 13px !important; color: black;" v-html="itemTutorialItem.description"></div>
                                    </v-col>
                                    <v-col 
                                        cols="12"
                                        lg="3"
                                        md="3"
                                        sm="12"
                                    >
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <a v-on="on" style="font-size: 13px;" v-bind:href="itemTutorialItem.url" target="_blank">{{ itemTutorialItem.url }}</a>
                                            </template>
                                            <span>Open link</span>
                                        </v-tooltip>
                                    </v-col>
                                    <v-col 
                                        style="display: flex; align-items: flex-start;"
                                        cols="12"
                                        lg="3"
                                        md="3"
                                        sm="12"
                                    >
                                        <div style="width: 100px; margin: 10px;" v-for="(itemDoc, index) in itemTutorialItem.docs" :key="index">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on }">
                                                    <div class="quickAccessButtons">
                                                        <v-btn 
                                                            style="width: 45px; border: none !important;"
                                                            class="btnActions"
                                                            outlined
                                                            v-on="on"
                                                            color="var(--color__main) !important"
                                                            small
                                                            @click="downloadFile(URL_ATTACHMENT, itemDoc.id, 'application/pdf', itemDoc.fileName);"
                                                        >
                                                            <v-icon v-on="on" large>mdi-file-document-outline</v-icon>
                                                        </v-btn>
                                                        <label>{{ itemDoc.fileName }}</label>
                                                    </div>
                                                </template>
                                                <span>{{ itemDoc.fileName }}</span>
                                            </v-tooltip>

                                        </div>
                                    </v-col>
                                </v-row>

                            </v-expansion-panel-content>
                        </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Helpers from '@/utilities/Helpers';
    import {
        URL_ATTACHMENT,
        TYPE_DOCUMENT, 
        TYPE_ATTACHMENT 
    } from "@/utilities/Enums";

    export default ({

        mixins: [Helpers],

        data: () => ({

            listTutorial: [],

            URL_ATTACHMENT: URL_ATTACHMENT
        }),

        computed: {
            ...mapGetters('logInModule', { userLoggedGetters: 'searchState' }),
        },

        methods: {
            async getLists() {

                const idProfile = this.userLoggedGetters.profile.systemAdmin == 1 ? 0 : this.userLoggedGetters.profile.id;
                
                this.listTutorial = await this.$store.dispatch("tutorialModule/List", { idProfile, showOnlyActive: true });

                this.listTutorial.forEach(async itemTutorial => {

                    itemTutorial.listItem.forEach(async item => {

                        const listAttachments = await this.$store.dispatch("attachmentModule/GetAll", { typeAttachment: TYPE_ATTACHMENT.TUTORIAL.value, idKey: item.id }); 

                        const listDocs = listAttachments.filter(atc => atc.typeDocument == TYPE_DOCUMENT.DOCUMENTS.value);

                        item.filesDocs = [];
                        item.docs = [];

                        listDocs.forEach(itemDoc => {

                            item.docs.push({
                                id: itemDoc.id,
                                file: new File([], itemDoc.fileName),
                                type: itemDoc.fileType,
                                fileName: itemDoc.fileNameShort,
                                deleted: false
                            })
                        })

                        this.$forceUpdate();
                    });
                });
            },
        },

        created() {
            this.showLoading();

            this.getLists();

            this.hideLoading();
        }
    })
</script>
